import React, { useEffect, useState } from "react";
import {
  Container,
  Modal,
  Card,
  Button,
  Row,
  Col,
  ListGroup,
  Spinner,
  Alert,
} from "react-bootstrap";
import Dashboard from "../components/MerchantDashboard";
import CustomHelmet from "../components/CustomHelmet";
import { Link } from "react-router-dom";
import axios from "axios";
import Fade from "react-reveal/Fade";

const url = "https://www.hubsquares.com/php_files/fetchOwner.php/";
const urlUpload = "https://www.hubsquares.com/php_files/processPic.php/";
const urlPass = "https://www.hubsquares.com/php_files/processPass.php/";
const urlSub = "https://www.hubsquares.com/php_files/fetchSubscription.php/";
const urlSCancelSub = "https://www.hubsquares.com/php_files/processCancelSub.php/";
const urlSCancelStandardSub = "https://www.hubsquares.com/php_files/processCancelStandardSub.php/";

const Profile = (props) => {
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [spin, setSpin] = useState(false);
  const [spinPass, setSpinPass] = useState(false);
  const [show, setShow] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [image, setImage] = useState(null);
  const [plan, setPlan] = useState("");
  const [error, setError] = useState(false);
  const [errorPass, setErrorPass] = useState(false);
  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newConfirmPass, setNewConfirmPass] = useState("");
  const [errorValue, setErrorValue] = useState("");
  const [errorValuePass, setErrorValuePass] = useState("");
  const [subDetails, setSubDetails] = useState("");
  useEffect(() => {
    const fetchListing = async () => {
      const fetchSub = () => {
        axios.post(urlSub, { owner: props.user }).then((res) => {
          if (res.data.success === 1) {
            setSubDetails(res.data.subscription[0]);
            setPlan(res.data.subscription[0].package);
          }
        });
      };
      fetchSub();
      // const formData = new FormData();
      await axios.post(url, { owner: props.user }).then((res) => {
        setDetails(res.data.user);
        setLoading(false);
      });
    };
    if (props.user) fetchListing();
  }, [props.user]);
  function onUpload() {
    setSpin(true);
    let formData = new FormData();
    formData.append("owner", props.user);
    formData.append("picture", image);
    axios
      .post(urlUpload, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.success === 1) {
          setSpin(false);
          setErrorValue(res.data.msg);
          setError(true);
          props.history.push("/profile");
        } else if (res.data.success === 0) {
          setErrorValue(res.data.msg);
          setSpin(false);
          setError(true);
        }
      });
  }

  function onChangePass(e) {
    e.preventDefault();
    if (newPass !== "" && currentPass !== "" && newPass === newConfirmPass) {
      setSpinPass(true);
      let formData = new FormData();
      formData.append("owner", props.user);
      formData.append("current", currentPass);
      formData.append("new", newPass);
      axios.post(urlPass, formData).then((res) => {
        if (res.data.success === 1) {
          setSpinPass(false);
          setErrorValuePass(res.data.msg);
          setErrorPass(true);
          props.history.push("/profile");
        } else if (res.data.success === 0) {
          setErrorValuePass(res.data.msg);
          setSpinPass(false);
          setErrorPass(true);
        }
      });
    } else if (newPass !== newConfirmPass) {
      setErrorPass(true);
      setErrorValuePass("New password and Confirm new password does not match");
    }
  }
  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error]);
  useEffect(() => {
    if (errorPass) {
      setTimeout(() => {
        setErrorPass(false);
        setErrorValuePass("");
      }, 5000);
    }
  }, [errorPass]);

  function onCancel() {
    let confirm = window.confirm(
      "This action will change your plan to basic plan and customers won't be able to see your contact details"
    );
    if (confirm) {
      axios
        .post(urlSCancelStandardSub, {
          owner: props.user,
          subscriptionID: subDetails.subscriptionID,
        })
        .then((res) => {
          if (res.data.success === 1) props.history.push("/profile");
        });
    }
  }
  function onCancelBasic() {
    let confirm = window.confirm("This action will delete your business");
    if (confirm) {
      axios.post(urlSCancelSub, { owner: props.user }).then((res) => {
        if (res.data.success === 1) props.history.push("/profile");
      });
    }
  }
  return (
    <>
      <CustomHelmet page="Profile" />
      <Dashboard user={props.user} page="Profile Details">
        <Container className="mt-3">
          <Card>
            {loading ? (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            ) : (
              <Card.Body>
                <Card.Body>
                  <Row>
                    <Col md={3} className="d-flex justify-content-center">
                      {details.picture ? (
                        <div style={{ height: 128, width: 128 }}>
                          <img
                            height="100%"
                            width="100%"
                            style={{ borderRadius: "50%" }}
                            src={`https://www.hubsquares.com/php_files/picture/${details.picture}`}
                            alt={details.firstname}
                          />
                        </div>
                      ) : (
                        <i
                          className="fa fa-user-circle text-grey"
                          style={{ fontSize: "7rem" }}
                        />
                      )}
                    </Col>
                    <Col md={9}>
                      <p className="paragraph-form">
                        Update your photo manually If the photo is not set the
                        default Gravatar will be the same as your login email
                        account
                      </p>
                      <Button
                        variant="danger"
                        onClick={() => setShow(true)}
                        className="addbtn mr-2"
                      >
                        Change Photo
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => setShowPass(true)}
                        className="addbtn"
                      >
                        Change Password
                      </Button>
                    </Col>
                  </Row>

                  <ListGroup variant="flush" className="my-3">
                    <ListGroup.Item>
                      <div className="row">
                        <div className="col-md-5"> First Name</div>
                        <span className="text-new-grey col-md-7 d-flex ml-auto">
                          {details.firstname}
                        </span>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="row">
                        <div className="col-md-5">Last Name</div>
                        <span className="text-new-grey col-md-7 d-flex ml-auto">
                          {details.lastname}
                        </span>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="row">
                        <div className="col-md-5">Phone Number</div>
                        <span className="text-new-grey col-md-7 d-flex  ml-auto">
                          {details.phone}
                        </span>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="row">
                        <div className="col-md-5"> Email </div>
                        <span className="col-md-7 d-flex text-new-grey ml-auto">
                          {details.email}
                        </span>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className="row">
                        {plan && <div className="col-md-5">Plan</div>}
                        <div className="text-new-grey col-md-7 row ml-0">
                          <span className="text-left col-6 p-0">{plan}</span>
                          <div className="col-6">
                            {plan === "Basic plan" && (
                              <div>
                                <Link
                                  className="text-decoration-none"
                                  to="/change-plan"
                                >
                                  <Button
                                    className="border-0"
                                    variant="outline-warning"
                                  >
                                    Upgrade
                                  </Button>
                                </Link>
                                <Button
                                  variant="outline-danger"
                                  onClick={onCancelBasic}
                                  className="border-0 cancel-btn"
                                >
                                  Cancel
                                </Button>
                              </div>
                            )}
                            {plan === "Standard plan (monthly)" && (
                              <Button
                                variant="outline-danger"
                                onClick={onCancel}
                                className="border-0 cancel-btn"
                              >
                                Cancel
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Body>
              </Card.Body>
            )}
          </Card>
        </Container>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Select image to upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              accept=".jpg,.jpeg,.png"
              name="logo"
              onChange={(e) => {
                setImage(e.target.files[0]);
              }}
              type="file"
              className="form-control"
              id="customFile2"
            />
            {error && (
              <div className="my-3">
                <Fade bottom collapse when={error}>
                  <Alert
                    variant={
                      errorValue === "Profile picture changed"
                        ? "success"
                        : "danger"
                    }
                  >
                    {errorValue}
                  </Alert>
                </Fade>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={spin} onClick={onUpload}>
              Upload
              {spin && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showPass}
          onHide={() => setShowPass(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="form-group">
                <input
                  type="password"
                  required
                  className="form-control"
                  placeholder="Current Password"
                  value={currentPass}
                  onChange={(e) => setCurrentPass(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  required
                  className="form-control"
                  placeholder="New Password"
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  required
                  className="form-control"
                  placeholder="Confirm New Password"
                  value={newConfirmPass}
                  onChange={(e) => setNewConfirmPass(e.target.value)}
                />
              </div>
              {errorPass && (
                <div className="my-3">
                  <Fade bottom collapse when={errorPass}>
                    <Alert
                      variant={
                        errorValuePass === "Password changed"
                          ? "success"
                          : "danger"
                      }
                    >
                      {errorValuePass}
                    </Alert>
                  </Fade>
                </div>
              )}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              disabled={spinPass}
              onClick={onChangePass}
              type="submit"
            >
              Change
              {spinPass && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Dashboard>
    </>
  );
};
export default Profile;
